function moveGallery(element, position, direction) {
  var parentElement = $( '#' + $(element).data('parent') );

  if ( direction == 'left' ) {
    parentElement.animate({scrollLeft:"-="+position}, 200, 'easeOutExpo');
  } else if ( direction == 'right') {
    parentElement.animate({scrollLeft:"+="+position}, 200, 'easeOutExpo');
  }
}

function displayGallery(target) {
  if ( target == 'type' ) {
    if ( $( "#skin_concern_container" ).is( ":visible" ) ) {
      $( "#skin_concern_container" ).fadeTo( "slow", 0 );
      $( "#skin_concern_container" ).hide();
    }

    if ( $( "#skin_routine_container" ).is( ":visible" ) ) {
      $( "#skin_routine_container" ).fadeTo( "slow", 0 );
      $( "#skin_routine_container" ).hide();
    }

    $( "#skin_type_container" ).fadeTo( "slow", 1 );
    
    $( "#skin_concern_button" ).removeClass( "bottom-outlined-pink" );
    $( "#skin_routine_button" ).removeClass( "bottom-outlined-pink" );

    $( "#skin_type_button" ).addClass( "bottom-outlined-pink" );
  } else if ( target == 'concern' ) {
    if ( $( "#skin_type_container" ).is( ":visible" ) ) {
      $( "#skin_type_container" ).fadeTo( "slow", 0 );
      $( "#skin_type_container" ).hide();
    }

    if ( $( "#skin_routine_container" ).is( ":visible" ) ) {
      $( "#skin_routine_container" ).fadeTo( "slow", 0 );
      $( "#skin_routine_container" ).hide();
    }

    $( "#skin_concern_container" ).fadeTo( "slow", 1 );

    $( "#skin_type_button" ).removeClass( "bottom-outlined-pink" );
    $( "#skin_routine_button" ).removeClass( "bottom-outlined-pink" );

    $( "#skin_concern_button" ).addClass( "bottom-outlined-pink" );
  } else if ( target == 'routine' ) {
    if ( $( "#skin_concern_container" ).is( ":visible" ) ) {
      $( "#skin_concern_container" ).fadeTo( "slow", 0 );
      $( "#skin_concern_container" ).hide();
    }

    if ( $( "#skin_type_container" ).is( ":visible" ) ) {
      $( "#skin_type_container" ).fadeTo( "slow", 0 );
      $( "#skin_type_container" ).hide();
    }

    $( "#skin_routine_container" ).fadeTo( "slow", 1 );

    $( "#skin_concern_button" ).removeClass( "bottom-outlined-pink" );
    $( "#skin_type_button" ).removeClass( "bottom-outlined-pink" );

    $( "#skin_routine_button" ).addClass( "bottom-outlined-pink" );
  }
}